// extracted by css-extract-rspack-plugin
export default {"page-content":"page-content-vWUd1L","pageContent":"page-content-vWUd1L"};